import script from "./editReceiveRecordModal.vue?vue&type=script&setup=true&lang=jsx"
export * from "./editReceiveRecordModal.vue?vue&type=script&setup=true&lang=jsx"

const __exports__ = script;

export default __exports__